import { Form } from '~/shared/forms/Form';
import type { NewCustomInterventionState } from '../reducer/wizardReducer';
import { InterventionCard } from '../../interventions/InterventionCard';
import { addDays } from '~/util/date';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { getCustomInterventionValidationSchema } from '../../interventions/util';
import { CustomInterventionFormFields } from '../../interventions/CustomInterventionFormFields';

const today = new Date();

export function getCustomInterventionInitialValues(
	intervention: NewCustomInterventionState,
	defaultAssignedDisciplineId?: number,
	projectedEndDateForNewInterventions?: Date
) {
	return {
		subject: `Custom Intervention #${intervention.customInterventionNumber}`,
		definitionText: null,
		interventionTypeId: null,
		canBePerformedByPatient: false,
		canBePerformedByCaregiver: false,
		projectedStartDate: today,
		projectedEndDate: !projectedEndDateForNewInterventions
			? addDays(today, 1)
			: addDays(today, 30) > projectedEndDateForNewInterventions
			? projectedEndDateForNewInterventions
			: addDays(today, 30),
		assignedDisciplineId: defaultAssignedDisciplineId,
		notes: null,
		interventionTypeIds: [],
		...intervention.formValues
	};
}

export function CustomInterventionForm({ intervention }: { intervention: NewCustomInterventionState }) {
	if (!intervention.customInterventionNumber) {
		throw new Error('Custom intervention number is required');
	}
	const { certificationPeriod, defaultAssignedDisciplineId } = useGoalsAndInterventionsWizard();
	const initialValues = getCustomInterventionInitialValues(intervention, defaultAssignedDisciplineId, certificationPeriod.endDate);
	const validationSchema = getCustomInterventionValidationSchema(certificationPeriod.endDate);
	return (
		<InterventionCard
			interventionDefinition={{
				title: 'Custom',
				definitionText: 'Custom intervention definition',
				documentationWorkflows: [],
				restrictedToClinicalTypes: []
			}}
		>
			<div className="w-full pt-5">
				<Form initialValues={initialValues} validationSchema={validationSchema} registryId={intervention.id}>
					{formHelpers => (
						<>
							{formHelpers.displayErrorElement && formHelpers.errorElement}
							<CustomInterventionFormFields />
						</>
					)}
				</Form>
			</div>
		</InterventionCard>
	);
}
